// iter 403 — mounts the click-usage tracker for authenticated staff sessions.
import { useEffect } from "react";
import { startUsageTracker } from "../lib/usageTracker";

export default function UsageTracker() {
  useEffect(() => startUsageTracker(), []);
  return null;
}
